
import { connect } from 'react-redux'
import { compose, branch, renderComponent, renderNothing } from 'recompose'
import PhotoTillage from './PhotoTillage'

const Component = compose(

  connect(state => {
    return {
      items: state.breadcrumb
    }
  }),
  branch(
    () => {
      return true
    },
    renderComponent(PhotoTillage),
    renderNothing
  )
)(PhotoTillage)

export default Component